import { Pipe, PipeTransform } from '@angular/core';
import { EnumsNiceLabelUtils } from '../../utils/enums-nice-label.utils';

@Pipe({
  name: 'fileSizeDisplay',
})
export class FileSizeDisplayPipe implements PipeTransform {
  transform(size: number): string {
    return fileSizeDisplayTransform(size);
  }
}

export function fileSizeDisplayTransform(size: number) {
  return EnumsNiceLabelUtils.fileSize(size);
}
